// The rule for a user-typed PROJECT FOLDER name, in one place.
//
// It is enforced twice on purpose — the dialog greys out its actions so the user is told
// before they act, and the main process refuses as a backstop so nothing reaches mkdir on
// trust alone. Those two checks must never disagree, which is why the rule lives here and
// not once per caller.
//
// A folder name is not a plugin id (see safePluginFolderId in the engine's
// folder-discovery): it is human-facing, so spaces, dots and dashes are ordinary and
// allowed. What is rejected:
//
//   path separators   -> the name must never escape the resolved project root
//   a leading dot     -> ".openanalyst" / ".git" would collide with real project internals
//   a trailing dot    -> Windows silently strips it, so the folder created is not the one asked for
//   < > : " | ? *     -> illegal on Windows, silently mangled elsewhere
//   control characters
const ILLEGAL = /[\\/:*?"<>|]/

export function isPlainProjectFolderName(input: string | undefined): boolean {
  return safeProjectFolderName(input) !== undefined
}

/** The trimmed name when it is a usable folder name, otherwise undefined (including blank). */
export function safeProjectFolderName(input: string | undefined): string | undefined {
  const value = input?.trim()
  if (!value) return undefined
  if (value === "." || value === "..") return undefined
  if (value.startsWith(".")) return undefined
  if (value.endsWith(".")) return undefined
  if (ILLEGAL.test(value)) return undefined
  if (Array.from(value).some((char) => char.charCodeAt(0) < 0x20 || char.charCodeAt(0) === 0x7f)) return undefined
  return value
}
